<template>
    <v-menu offset-y>
        <template v-slot:activator="{ props }">
            <v-btn v-bind="props" icon class="mx-1" color="primary">
                <v-icon>$dots_vertical</v-icon>
            </v-btn>
        </template>
        <v-list nav>
            <v-list-item
                @click="activeTabSync = 'document'"
                v-if="isAccountingUser && type !== 'EXPENSE_REPORT_DOCUMENT'"
            >
                <v-list-item-title>Document</v-list-item-title>
                <template v-slot:append>
                    <v-icon size="small">$oss-file</v-icon>
                </template>
            </v-list-item>
            <v-list-item
                @click="activeTabSync = 'accountingLines'"
                v-if="isAccountingUser && type !== 'EXPENSE_REPORT_DOCUMENT'"
                :disabled="status !== 'VALIDATED'"
            >
                <v-list-item-title>&#xc9;critures comptables</v-list-item-title>
                <template v-slot:append>
                    <v-icon size="small">$oss-accounting-lines</v-icon>
                </template>
            </v-list-item>
            <v-list-item
                v-if="activeTabSync === 'document' && !!document.original"
                @click="startDownloadFile"
            >
                <v-list-item-title>Télécharger</v-list-item-title>
                <template v-slot:append>
                    <v-icon size="small">$oss-download</v-icon>
                </template>
            </v-list-item>
            <v-list-item
                @click="accountingLinesLockedDialogSync = true"
                v-if="!isIncomingOutgoingPayment && document.type !== 'EXPENSE_REPORT_DOCUMENT'"
            >
                <v-list-item-title>&#xc9;critures manuelles</v-list-item-title>
                <template v-slot:append>
                    <v-icon size="small">$oss-edit</v-icon>
                </template>
            </v-list-item>
            <v-list-item @click="analyseDocumentDialogSync = true" v-if="restartAnalysis">
                <v-list-item-title>Relancer l'analyse</v-list-item-title>
                <template v-slot:append>
                    <v-icon size="small">$oss-scan</v-icon>
                </template>
            </v-list-item>
            <v-list-item @click="activeTabSync = 'activity'" v-if="isAccountingUser">
                <v-list-item-title>Afficher l'activité</v-list-item-title>
                <template v-slot:append>
                    <v-icon size="small">$oss-activity</v-icon>
                </template>
            </v-list-item>
            <v-divider class="pb-2" />
            <v-list-item
                @click="deleteDocumentDialogSync = true"
                :disabled="disabledDelete"
                color="error"
                :active="!disabledDelete"
            >
                <v-list-item-title>Supprimer</v-list-item-title>
                <template v-slot:append>
                    <v-icon size="small">$oss-trash</v-icon>
                </template>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script lang="ts">
import { User } from "../../store/store";
import { downloadFileDocument } from "../../services/documentServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component
export class DocumentDropDown extends Vue {
    @Prop({ required: true, type: Object }) document!: any;
    @Prop({ required: true, type: Boolean }) isIncomingOutgoingPayment!: boolean;
    @Prop({ required: true, type: Boolean }) restartAnalysis!: boolean;
    @Prop({ required: true, type: Boolean }) disabledDelete!: boolean;

    @Model({ required: true, type: Boolean, name: "showAccountingLines" })
    showAccountingLinesSync!: boolean;

    @Model({ required: true, type: String, name: "activeTab" }) activeTabSync!:
        | "document"
        | "accountingLines"
        | "activity";

    @Model({ required: true, type: Boolean, name: "accountingLinesLockedDialog" })
    accountingLinesLockedDialogSync!: boolean;

    @Model({ required: true, type: Boolean, name: "analyseDocumentDialog" })
    analyseDocumentDialogSync!: boolean;

    @Model({ required: true, type: Boolean, name: "deleteDocumentDialog" })
    deleteDocumentDialogSync!: boolean;

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get type(): string {
        return this.document.type;
    }

    get status(): string {
        return this.document.status;
    }

    startDownloadFile() {
        downloadFileDocument({ documentId: this.document.id, original: true, workingCopy: false });
    }
}

export default toNative(DocumentDropDown);
</script>
